<template>
    <div id="login">
        <div class="box hide-scrollbars">
            <div class="info">
                <img class="logo main" src="/img/logo_new.png">
                
                <div v-if="!intime || errorPasswords" class="message error" style="text-align: center">{{message}}</div>
                <div v-if="changedSuccess" class="message success" style="text-align: center">{{message}}</div>

                <div class="language">
                    <div class="lang" @click="changeLang('ca')">Català</div>
                    <div class="lang" @click="changeLang('es')">Español</div>
                </div>

                <template v-if="intime">
                  <div v-if="!changedSuccess" class="title">{{$t('login.reset_password')}}</div>
                    <template v-if="!changedSuccess">
                        <div class="form">
                          <input type="password" name="password1" v-model="input.password1" :placeholder="$t('login.new_password')" v-on:focus="onfocus = true" />
                          <input type="password" name="password2" v-model="input.password2" :placeholder="$t('login.repeat_password')" v-on:keyup.enter="changePassword()" v-on:focus="onfocus = true" />
                          <button type="button" v-on:click="changePassword()">{{$t('login.reset_password')}}</button>
                        </div>
                    </template>
                    <router-link to="/login" class="remember">{{$t( 'login.back' )}}</router-link>
                </template>
            </div>
        </div>

        <div @click="goIntowin" class="tech-partner" :class="{onfocus: onfocus}"></div>

    </div>
</template>

<script>
    import {Api} from '@/core/api.js';
    const api = new Api();

    import i18n from '@/i18n'

    export default {
        name: 'ChangePassword',
        data() {
            return {
                input: {
                    password1: "",
                    password2: ""
                },
                message: false,
                intime: false,
                changedSuccess: false,
                onfocus: false,
                errorPasswords: false
            }
        },
        mounted() {
            let lang = this.$route.params.lang;
            var self = this;
            i18n.loadLanguageAsync(lang).then(function(){
                let timestamp = self.$route.params.limit;
                if( moment().valueOf() <= moment( timestamp * 1000 ).valueOf() ){
                    self.intime = true;
                }
                else{
                    self.message = i18n.t( 'login.link_expired')
                }
            });
        },
        methods: {
            changePassword() {
                var self = this;

                if( !isEmpty(this.input.password1) && !isEmpty(this.input.password2) ) {

                  let password1 = sha256( this.input.password1 );
                  let password2 = sha256( this.input.password2 );

                  if( password1 != password2 ){

                      self.message = i18n.t( 'errors.different_passwords' );
                      self.errorPasswords = true;

                  } else {
                      api.post( 'changepassword', { id: this.$route.params.id, password: password1 } ).then( function( response ){
                          if( response.status ) {
                              self.message = i18n.t( 'login.reset_success' );
                              self.changedSuccess = true;
                              self.errorPasswords = false;

                          } else {
                              self.message = i18n.t( 'errors.api' );
                              self.errorPasswords = true;
                          }
                      });
                  }
                  
                } else {

                  self.message = i18n.t( 'errors.different_passwords' );
                  self.errorPasswords = true;

                }

            },

            changeLang(lang) {
                this.$route.params.lang = lang;
                i18n.loadLanguageAsync(lang);
            },

            goIntowin(){
                window.open('http://www.intowin.io','_blank');
            },
        }
    }
</script>

<style lang="scss" scoped>

  #container {
    padding: 0 !important;
  }

  .language {
      position: absolute;
      top: 10px;
      right: 10px;

      .lang {
        padding: 0 10px;
        font-weight: bold;
        font-size: 20px;
        float: left;
        // font-family: AvantGarde-Bold;
        cursor: pointer;
        color: white;

          &:not(:first-child) {
              border-left: 1px solid white;
          }
      }
  }

  #login {
    width: 100%;
    height: 100vh;
    margin: 0;
    padding: 25px;
    background: $dark-color;
    // background: linear-gradient(0deg, rgb(245, 245, 245), #FFF);
    // color: $secondary-color;
    overflow: auto;

    .box {
        max-width: 275px;
        width: 100%;
        height: auto;
        max-height: calc(100% - 40px);
        margin: 0 auto;
        overflow: auto;
        text-align: center;

        .message.error {
            background-color: #f73f2061;
            margin: 10px 0;
            border: 2px solid #e61515;
            border-radius: 5px;
            padding: 10px;
            color: #FFF;
            font-weight: bold;
        }

        .title {
          color: white;
        }

        .info {
          text-align: center;

          .logo {
            display: inline-block;
            height: 150px;
            padding: 15px;

            &.main {
                height: 100px;
            }
          }

          .description {
            width: 100%;
            display: block;
            color: white;
            font-size: 16px;
            text-align: center;
          }
        }
        .form  {
          margin-top: 50px;
        }

        input {
          width: 100%;
          padding: 15px;
          margin-bottom: 5px;
          border: 1px solid #444;
          outline: none;
          font-size: 11pt;
          border-radius: 3px;
          color: white;
          display: block;

          &::placeholder{
            color: white;
          }
        }

        button {
          width: calc(100%);
          padding: 12px;
          outline: none;
          border: none;
          cursor: pointer;
          font-size: 12pt;
          border-radius: 3px;
          text-transform: uppercase;
          transition: all 0.5s;
          background-color: $secondary-color;
          color: #000;
          margin-top: 12px;
          font-weight: bold;

          &.secondary {
            background: none;
            text-transform: initial;
            color: #999;
            font-weight: lighter;
            
            &:hover {
              text-decoration: underline;
            }
          }

          &:hover {
            // background-color: white;
            // color: #fff;
          }
        }


        button + .mlanguage {
          width: calc(100% - 50px);
        }

        button + .mlanguage, .mlanguage {
          display: inline-block;
          margin-top: 12px;
          height: 40px;
        }
        .mlanguage {
          float: none;
        }

        .remember {
            font-size: 10pt;
            margin-top: 20px;
            color: $secondary-color;
            cursor: pointer;
            display: block;
            text-decoration: none;
            text-align: center;
            color: #999;
            text-decoration: underline;

            &:hover {
                text-decoration: underline;
            }
        }

        .success {
          border: 2px solid #087908;
          border-radius: 5px;
          background-color: #a0f8b6;
          color: #000;
          padding: 10px;
          font-size: 16px;
          text-align: center;
        }

    }

    .tech-partner {
      @include display-flex();
      @include align-items(center);
      @include justify-content(center);
      position: fixed;
      // position: fixed;
      bottom: 10px;
      left: 0;
      width: 100%;
      text-align: center;
      height: 50px;
      @include background( $image: img('intowin_partner_v2.png'), $size: 250px, $position:  center );
      cursor: pointer;
    }
  }

  @include media("<=desktop") {
    #login {
      overflow: hidden;
      margin-top: 50px;

      .box .info .logo {
        height: 100px;
        padding: 6px;
        width: auto;
      }
      .box .form  {
        margin-top: 24px;
      }

      .tech-partner.onfocus {
          display: none;
      }
    }

  }

</style>
<style lang="scss">
    #login {
        .v-input {
            margin-bottom: 5px;
            .v-input__slot, .v-input__slot:hover {
                border: 1px solid #000;

                .v-select__selections {
                    padding-top: 0;
                    input::-webkit-input-placeholder {
                        color: #000;
                    }
                }
            }
        }
    }
</style>